// MyProvider.js
import React, { createContext, useState } from "react";
export const MyContext = createContext();
export const MyProvider = ({ children }) => {
    const [isOpenMain, setIsOpenMain] = useState(false);
    const toggleDropdownMain = () => {
        setIsOpenMain(!isOpenMain);
    };



    return (
        <MyContext.Provider
            value={{
                isOpenMain,
                setIsOpenMain,
                toggleDropdownMain,
            }}
        >
            {children}
        </MyContext.Provider>
    );
};
